import db from "../_root/apiBridge";
import { timestamp } from "../_root/apiBridge";

export async function getAdminSlideEditInsert(query: any): Promise<any> {
  return new Promise((resolve, reject) => {

    delete query.id;

    try {
      db.collection("slide")
        .add(query)
        .then(function (refDoc) {
          resolve({
            id: refDoc.id,
          });
        }).catch((error) => {
          reject(error);
        });
    } catch (error) {
      reject(error);
    }
  });
}

export async function getAdminSlideEditUpdate(
  id: string,
  query: any
): Promise<any> {
  return new Promise((resolve, reject) => {
    db.collection("slide")
      .doc(id)
      .update(query)
      .then(() => {
        resolve({
          id,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}


export async function getAdminSlideEditElim(id: string): Promise<any> {
  return new Promise((resolve, reject) => {
    try {
      db.collection("slide")
        .doc(id)
        .delete()
        .then(() => {
          resolve({
            id,
          });
        }).catch((error) => {
          reject(error);
        });
    } catch (error) {
      reject(error);
    }
  });
}
